import React from "react";
import { StyledAddMoreBox } from "./style";
import shoppingBag from "../../assets/images/shopping-bag.png";
import CustomButton from "../common/button/CustomButton";
import theme from "../../theme";
import { Box } from "@mui/material";
import DisabledTooltipWrap from "../common/disabled-tooltip-wrap/DisabledTooltipWrap";

const BlockLock = ({
  border,
  handleOpen,
  disabled = false,
  disabledReason = "",
}) => {
  const button = (
    <CustomButton
      fontSize={theme.typography.mini.fontSize}
      height="29px"
      btnLabel="Add More Items"
      btntype="primary"
      onClick={handleOpen}
      disabled={disabled}
    />
  );

  return (
    <StyledAddMoreBox border={border}>
      <Box
        sx={{
          height: "170px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          justifyContent: "center",
        }}
      >
        <img
          loading="lazy"
          width="70px"
          height="70px"
          src={shoppingBag}
          alt="shoppingBag"
        />
        <DisabledTooltipWrap title={disabledReason} disabled={disabled}>
          {button}
        </DisabledTooltipWrap>
      </Box>
    </StyledAddMoreBox>
  );
};

export default BlockLock;
